import ResponseSingleGradeStep from "./ResponseSingleGradeStep";


const ResponseGradeStepsMain = ({responseGradeSteps, setResponseGradeSteps, updateGradeFromSteps}) => {
 
    const editStep = (step) => {
        const updatedSteps = responseGradeSteps.map((s) =>  s._id=== step._id ? step : s);
        setResponseGradeSteps(updatedSteps);
    }
    const updateGrade = (total) => {
        updateGradeFromSteps(total);
    }
    const fillGrade = () => {
        const updatedSteps = responseGradeSteps.map((s) =>  {
            if (!s.grade || s.grade === 0) {
                return {
                    ...s,
                    grade: s.baseGrade
                };
            }
            return s;
        });
        setResponseGradeSteps(updatedSteps);
    }
    const orderedSteps = [...responseGradeSteps].sort((a, b) => a.order - b.order);
    const totalGrade = orderedSteps.reduce((total, step) => total +  ( Number( step.grade) || 0), 0);
  return (
    <>
    {orderedSteps && orderedSteps.length > 0 ? (<>
{orderedSteps.map((step, index) => (<ResponseSingleGradeStep  key={index} gradeStep={step} editStep={editStep}  />))}
<div className="flex items-center justify-between border-b border-gray-800 gap-2 p-2">
<span className="text-xlg font-semibold p-2">Total: {totalGrade}%</span>
<div>
<button className="text-blue-500 px-4 py-2 " onClick={() => updateGrade(totalGrade)}>
  עדכן ציון
</button>
<button className="text-blue-500 px-4 py-2 " onClick={() => fillGrade()}>
השלם ציון
</button>
</div>

</div>
    </>) : (
        <div className="text-center text-gray-500">No grade steps available</div>
    )}
   
    </>
  )
}

export default ResponseGradeStepsMain